import React from 'react';
import { Check, Circle } from 'lucide-react';
import { usePasswordValidation } from '@/hooks/usePasswordValidation';
import { cn } from '@/lib/utils';

interface PasswordRequirementsProps {
  password: string;
  className?: string;
}

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  password,
  className,
}) => {
  const { requirements } = usePasswordValidation(password);

  return (
    <div className={cn('space-y-2', className)}>
      <p className="text-sm text-muted-foreground font-medium">Password requirements:</p>
      <div className="space-y-1.5">
        {requirements.map((requirement) => (
          <div
            key={requirement.id}
            className="flex items-center gap-2 text-sm"
          >
            {requirement.met ? (
              <Check className="h-4 w-4 text-green-600 dark:text-green-400" />
            ) : (
              <Circle className="h-4 w-4 text-muted-foreground" />
            )}
            <span
              className={cn(
                'transition-colors',
                requirement.met
                  ? 'text-green-600 dark:text-green-400'
                  : 'text-muted-foreground'
              )}
            >
              {requirement.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};